import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Form, Formik } from 'formik'
import Modal from '../../../../Modal/Modal'
import Input from '../../../../FormComponents/Input'
import axiosService from '../../../../../utils/AxiosService'
import { useParams } from 'react-router-dom';
import { toastError, toastSuccess } from '../../../../FormComponents/Toasts'
import { CampaignContext } from '../../../../../contexts/CampaignContext'
import { CampaignSectionSchema } from '../../../../../schemas/CampaignSectionSchema'
import { runInAction } from 'mobx'

export default observer(function CreateNewSectionModal({ isOpen, setIsOpen }) {
  const { id } = useParams()
  const { campaign } = useContext(CampaignContext)

  const addToSectionList = ({ name }, { setSubmitting }) => {
    return axiosService.post(
      `/api/project_manager/campaigns/${id}/campaign_authentication_statuses`,
      { campaign_authentication_status: { name } }
    ).then((camp_status) => {
      runInAction(() => {
        campaign.statuses.push(camp_status)
      })
      setIsOpen(false)
      toastSuccess('List added')
    }).catch(({ data: { error } }) => {
      toastError(error)
      setSubmitting(false)
    })
  }

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <Modal.Header>
        <span className="font-bold text-lg dark:text-white">Add list</span>
      </Modal.Header>
      <Formik
        validationSchema={CampaignSectionSchema}
        initialValues={{ name: '' }}
        onSubmit={addToSectionList}
      >
        {({ handleBlur, handleChange, values, errors, touched, isSubmitting }) => (
          <Form>
            <Modal.Body>
              <div className="w-[440px] flex flex-col gap-1">
                <label className="text-sm font-semibold text-rb-black dark:text-white">List name</label>
                <Input
                  autoFocus
                  topMargin="mt-0"
                  inputPaddingClass="px-3"
                  error={touched.name && errors.name}
                  placeholder="e.g. Shortlist"
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                />
                <p className="text-xs text-rb-lighter-grey dark:text-gray-400 mt-1">Added as a new column at the end of this campaign's influencer list. Hidden from clients until you make it visible.</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="w-full flex justify-between items-center">
                <Modal.DissmissButton className="rb-btn-cancel px-4 py-2 text-sm font-semibold rounded-lg">
                  Cancel
                </Modal.DissmissButton>
                <button
                  type="submit"
                  disabled={isSubmitting || !values.name.trim()}
                  className="px-4 py-2 text-sm font-semibold text-white bg-rb-green rounded-lg dark:text-rb-dark-mode disabled:opacity-50"
                >
                  {isSubmitting ? 'Creating...' : 'Create'}
                </button>
              </div>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
})
